import { useIntl } from 'react-intl';
import { View } from 'react-native';

import { ServiceModeBar } from 'components/app-header/mobile-header/service-mode-bar';
import { CardModalHeader } from 'components/card-modal-header';
import { HeaderPoints } from 'pages/cart/header-points';

import { DebugToggleButton } from './debug-toggle-button';

export const CartHeader = () => {
  const { formatMessage } = useIntl();
  return (
    <>
      <CardModalHeader
        {...{
          headerText: formatMessage({ id: 'yourOrder' }),
          dismissType: 'back',
          invertHeaderColor: true,
          customHeaderRight: (
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              <HeaderPoints />
              <DebugToggleButton />
            </View>
          ),
          isFullScreen: true,
        }}
      />
      <ServiceModeBar hideTopOrderStatusBar isInCart={true} />
    </>
  );
};
